import type { SerializedEditorState } from "lexical";

interface TextNode {
  type: string;
  text?: string;
  children?: TextNode[];
}

const blockNodeTypes = new Set(["code", "heading", "list", "listitem", "paragraph", "quote"]);

function extractText(node: TextNode): string {
  const text = typeof node.text === "string" ? node.text : "";
  const children = node.children?.map(extractText).join("") ?? "";
  return `${text}${children}${blockNodeTypes.has(node.type) ? "\n" : ""}`;
}

/**
 * Extract plain text from Lexical editor state
 */
export function getTextFromObject(obj: SerializedEditorState): string {
  // Assuming the structure starts from `root`
  if (obj?.root) {
    return extractText(obj.root)
      .replace(/\n{2,}/g, "\n")
      .trim();
  }
  return "";
}
